<template>
    <div class="notice-list-page" v-wechat-title="`通知公告_双优云桥-智慧研修平台`">
        <div class="notice-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <span class="cur">通知公告</span>
            </div>

            <div class="panel">
                <div class="panel-hd">
                    <h2>公告列表</h2>
                    <label class="search-box">
                        <i class="el-icon-search"></i>
                        <input
                            v-model.trim="keyword"
                            type="search"
                            placeholder="搜索公告标题"
                        />
                    </label>
                </div>

                <div class="notice-cards" v-loading="loading">
                    <a
                        v-for="item in filteredList"
                        :key="item.id"
                        href="javascript:;"
                        class="notice-card"
                        @click.prevent="goDetail(item)"
                    >
                        <h3>{{ item.title }}</h3>
                        <p v-if="item.summary">{{ item.summary }}</p>
                        <div class="meta">
                            <span>发布时间：{{ item.date }}</span>
                            <span v-if="item.org">发布单位：{{ item.org }}</span>
                        </div>
                    </a>

                    <ph-empty
                        v-if="!loading && filteredList.length === 0"
                        size="page"
                        :text="keyword ? '未找到匹配的公告' : '暂无公告'"
                        :subtext="keyword ? '请尝试更换搜索关键词' : ''"
                    />
                </div>

                <div class="pager-wrap" v-if="pages.total > 0 && !keyword">
                    <pagination
                        :total="pages.total"
                        :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize"
                        @pagination="handlePageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import pagination from '@/common/community/pagination.vue'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeNoticeList',
    components: { pagination, PhEmpty },
    data() {
        return {
            loading: false,
            keyword: '',
            tableData: [],
            pages: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    computed: {
        projectId() {
            return this.$route.params.id
        },
        filteredList() {
            if (!this.keyword) return this.tableData
            const key = this.keyword.toLowerCase()
            return this.tableData.filter(item =>
                (item.title || '').toLowerCase().includes(key)
            )
        }
    },
    methods: {
        formatDate(val) {
            if (!val) return '--'
            return dayjs(val).format('YYYY-MM-DD')
        },
        stripHtmlText(val) {
            if (!val) return ''
            return String(val)
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&amp;/gi, '&')
                .replace(/&lt;/gi, '<')
                .replace(/&gt;/gi, '>')
                .replace(/\uFFFD/g, '')
                .replace(/[\uE000-\uF8FF]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
        },
        cleanNoticeTitle(title) {
            return this.stripHtmlText(title)
        },
        mapItem(item) {
            return {
                id: item.id,
                title: this.cleanNoticeTitle(item.title || ''),
                date: this.formatDate(item.updateTime || item.createTime),
                summary: item.introduction || '',
                org: item.source || item.author || ''
            }
        },
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        goDetail(item) {
            this.$router.push({
                path: `/projectHome/${this.projectId}/notice/${item.id}`,
                query: { from: 'list' }
            })
        },
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.keyword = ''
            this.fetchList()
        },
        async fetchList() {
            if (!this.projectId) {
                this.tableData = []
                this.pages.total = 0
                return
            }
            this.loading = true
            try {
                const res = await this.$Api.Home.getNewsListByProjectId({
                    projectId: this.projectId,
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize
                })
                const data = (res && res.data) || {}
                const list = data.list || []
                this.tableData = list.map(item => this.mapItem(item))
                this.pages.total = data.totalCount || 0
            } catch (e) {
                this.tableData = []
                this.pages.total = 0
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
        this.fetchList()
    }
}
</script>

<style lang="less" scoped>
.notice-list-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.notice-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
}

.panel-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 24px;
    line-height: 56px;
    border-bottom: 1px solid rgba(199, 199, 199, 0.4);
    background: rgba(250, 251, 255, 1);

    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #333;
    }
}

.search-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 0 12px;
    border: 1px solid #e0e6ed;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;

    i {
        color: #999;
        font-size: 14px;
    }

    input {
        border: none;
        outline: none;
        width: 180px;
        font-size: 13px;
        color: #333;
        background: transparent;
        font-family: inherit;

        &::placeholder {
            color: #bbb;
        }
    }
}

.notice-cards {
    min-height: 240px;
}

.notice-card {
    display: block;
    padding: 16px 24px;
    border-bottom: 1px solid #f5f7fa;
    text-decoration: none;
    color: inherit;
    transition: background 0.2s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #EAF6FF;

        h3 {
            color: #01A2FD;
        }
    }

    h3 {
        margin: 0 0 8px;
        font-size: 15px;
        font-weight: 600;
        color: #333;
        line-height: 1.45;
    }

    p {
        margin: 0;
        font-size: 13px;
        color: #666;
        line-height: 1.6;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.meta {
    margin-top: 10px;
    font-size: 12px;
    color: #999;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    align-items: center;
}

.pager-wrap {
    padding: 8px 16px 16px;
}

@media screen and (min-width: 1250px) {
    .notice-wrap {
        width: 1200px;
    }
}
</style>
